import axios from 'axios';
import { CMS_API_BASE_URL } from './contentApi';

/**
 * City registry API — the multi-city tenant list.
 * Backed by /api/sumadhura-cms/cities (see backend city.controller.js).
 */
const CITIES_URL = `${CMS_API_BASE_URL}/cities`;

const getErrorMessage = (error, fallback) => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    const msg =
      (typeof data?.message === 'string' && data.message) ||
      (typeof data?.error === 'string' && data.error) ||
      error.message;
    return msg || fallback;
  }
  if (error instanceof Error) return error.message;
  return fallback;
};

/** List cities. @param {{status?: 'active'|'archived'|'all'}} opts */
export async function listCities({ status } = {}) {
  try {
    const res = await axios.get(CITIES_URL, { params: status ? { status } : {} });
    return Array.isArray(res.data?.data) ? res.data.data : [];
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Failed to load cities'));
  }
}

/** Create a city. @param {{displayName: string, projectId?: string}} body */
export async function createCity({ displayName, projectId }) {
  try {
    const res = await axios.post(CITIES_URL, { displayName, projectId });
    return res.data?.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Failed to create city'));
  }
}

/** Rename / archive a city (projectId is immutable). */
export async function updateCity(projectId, patch) {
  try {
    const res = await axios.patch(`${CITIES_URL}/${encodeURIComponent(projectId)}`, patch);
    return res.data?.data;
  } catch (error) {
    throw new Error(getErrorMessage(error, 'Failed to update city'));
  }
}
